import { message, notification, Button } from "antd";
import apiClient from "../api/apiClient";
import React from 'react'

var interval;
var guestLogin;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const requestEntry = (data) => async (dispatch) => {
  console.log("inside requestEntry");
  apiClient.post(BASE_URL + `/api/requestEntry`, data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("result",res.data);
      dispatch({
        type: "SET_REQUEST_SENT",
        payload: true,
      });
      dispatch({
        type: "SET_TRANSACTION_ID",
        payload: res.data.transaction_id,
      });
      console.log("Sucess");

      interval = setInterval(function () {
        dispatch(
          getLoanDetails({
            dealer_id: res.data.dealer_id,
            memberId: res.data.memberId,
            cardId: res.data.cardId,
          })
        );
      }, 5000);
    }
  }).catch((err)=>{
    console.log(err)
    if(err.response.status === 422){
      message.error("No Records Found For Card Number.",10)
    }
    else if(err.response.status === 409){
      message.error("Loan already processed for this card number.",10)
    }
    else if(err.response.status === 406){
      message.error("A transaction already exisits for the card number for your dealership. Please continue with the same transaction.",10)
    }
    else if(err.response.data.message){
      message.error(err.response.data.message,5)
    }
    else{
      message.error("Error occured please try again",10)
    }
  });
};
export const guestRequestEntry = (data) => async (dispatch) => {
  console.log("inside guestRequestEntry");
  apiClient.post(BASE_URL + `/api/guestRequestEntry`, data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("result",res.data);
      dispatch({
        type: "SET_REQUEST_SENT",
        payload: true,
      });
      dispatch({
        type: "SET_GUEST_LOAN_DATA",
        payload: data,
      });
      console.log("Sucess");

      guestLogin = setInterval(function () {
        dispatch(
          getGuestLoanDetails({
            dealer_nm: res.data.dealer_nm,
            memberId: res.data.memberId,
            cardId: res.data.loan_id,
            email: res.data.email,
          })
        );
      }, 5000);
    }
  }).catch((err)=>{
    console.log(err)
    if(err.response.status === 422){
      message.error("No Records Found For Card Number.",10)
    }
    else if(err.response.status === 409){
      message.error("Loan already processed for this card number.",10)
    }
    else if(err.response.status === 406){
      message.error("A transaction already exisits for the card number for your dealership. Please continue with the same transaction.",10)
    }
    else if(err.response.data.message){
      message.error(err.response.data.message,5)
    }
    else{
      message.error("Error occured please try again",10)
    }
  });
};
export const getLoanDetails = (data) => async (dispatch) => {
  console.log("inside getLoanDetails");
  console.log("loan details", data);

  apiClient.get(BASE_URL + `/api/loanData/${data.memberId}/${data.cardId}/${data.dealer_id}`, {
    headers: {
    },
  }).then((res) => {
    console.log(res)
    if (res.status === 200 && res.data !== "Access Invalid") {
      clearInterval(interval);
      console.log(res.data);
      let loandata = res.data[0];
      loandata.cardId = data.cardId;

      dispatch({
        type: "SET_LOAN_DATA",
        payload: loandata,
      });
      dispatch({
        type: "SET_LOAN_ACCESS",
        payload: true,
      });
      console.log("Sucess");
    } else {
      dispatch({
        type: "SET_LOAN_DATA",
        payload: false,
      });
    }
  });
};
export const getGuestLoanDetails = (data) => async (dispatch) => {
  console.log("inside getLoanDetails");
  console.log("loan details", data);

  apiClient.get(BASE_URL + `/api/guestLoanData/${data.memberId}/${data.cardId}/${data.dealer_nm}/${data.email}`, {
    headers: {
    },
  }).then((res) => {
    console.log(res)
    if (res.status === 200 && res.data !== "Access Invalid") {
      clearInterval(guestLogin);
      console.log(res.data);
      let loandata = res.data[0];
      loandata.cardId = data.cardId;

      dispatch({
        type: "SET_LOAN_DATA",
        payload: loandata,
      });
      dispatch({
        type: "SET_LOAN_ACCESS",
        payload: true,
      });
      console.log("Sucess");
    } else {
      dispatch({
        type: "SET_LOAN_DATA",
        payload: false,
      });
    }
  });
};

export const checkAccessValid = (data) => async (dispatch) => {
  console.log(data)
  console.log("inside");
  apiClient.post(BASE_URL + `/api/checkLoanAccess`, data, {
    headers: {
    },
  }).then((res) => {
    console.log("CHECK LOAN ACCESS", res)
    if (res.status === 200 && res.data === true) {
      dispatch({
        type: "SET_LOAN_ACCESS",
        payload: true,
      });
      console.log("Sucess");
    }
  });
};

export const createNewTransaction = (data) => async (dispatch) => {
  console.log("inside createNewTransaction");
  apiClient.post(BASE_URL + `/api/createRequest`, data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("createNewTransaction",res.data);
      dispatch({
        type: "SET_TRANSACTION_ID",
        payload: res.data.transaction_id,
      });
      console.log("Sucess");
    }
  });
};


export const getTransaction = (data) => async (dispatch) => {
  console.log("inside getTransaction");
  apiClient.get(BASE_URL + `/api/transactions?id=${data.dealerhost_id}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("getTransaction",res.data);
      dispatch({
        type: "SET_TRANSACTIONS",
        payload: res.data,
      });
      console.log("Sucess");
    }
  });
};
export const getDocuments = (transaction_id) => async (dispatch) => {
  console.log("inside getDocuments");
  apiClient.get(BASE_URL + `/api/documents/${transaction_id}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("createNewTransaction",res.data);
      dispatch({
        type: "SET_DOCUMENTS",
        payload: res.data,
      });
      console.log("Got document urls");
    }
  });
};
export const sendSubmitRequest = (data) => async (dispatch) => {
  console.log("inside sendSubmitRequest");
  apiClient.post(BASE_URL + `/api/transaction/submitRequest`,data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      message.success(res.data.message)
      interval = setInterval(function () {
        dispatch(
          getTransactionById(data.id)
        );
      }, 5000);
    }
  });
};
export const getTransactionById = (id) => async (dispatch) => {
  console.log("inside getTransactionById");
  apiClient.get(BASE_URL + `/api/transactions/${id}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200 && res.data[0]?.status === 'Completed' ) {
      clearInterval(interval);
      dispatch({
        type: "SET_CURRENT_TRANSACTION",
        payload: res.data[0],
      });
    }
    else if (res.status === 200 ) {
      console.log("getTransactionById",res.data);
      dispatch({
        type: "SET_CURRENT_TRANSACTION",
        payload: res.data[0],
      });
    }
  });
};
export const invite = (data, form) => async (dispatch) => {
  console.log("inside invite");
  apiClient.post(BASE_URL + `/api/dealerhosts/invite`, data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      form.resetFields();
      message.success("Invitation sent successfully")
    }
  })
  .catch((err) =>{
    console.log(err)
    if(err && err.response && err.response.status===409)
      message.error("User already exists. Try using another email address",10)
    else
      message.error("An error occured please try again")
  })
};
export const getDealerHosts = (id) => async (dispatch) => {
  console.log("inside getDealerHosts");
  apiClient.get(BASE_URL + `/api/team/${id}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200 && Array.isArray(res.data)) {
      dispatch({
        type: "SET_DEALERHOST_DATA",
        payload: res.data,
      });
    }
  })
  .catch((err) =>{
    message.error("An error occured. Please try again.")
  })
};
export const updateTransaction = (data) => async (dispatch) => {
  console.log("inside updateTransaction");
  apiClient.put(BASE_URL + `/api/transactions`,data, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: "SET_CURRENT_TRANSACTION",
        payload: res.data[0],
      });

      //dispatch(getLoanDetails({memberId:data.member_id, cardId: data.cardId, dealer_id:data.dealer_id}));
    }
  })
  .catch((err) =>{
    message.error("An error occured. Please try again.")
  })
};
export const getAllTransactions = (id) => async (dispatch) => {
  clearInterval(interval);
  console.log("inside getAllTransactions");
  apiClient.get(BASE_URL + `/api/transactions/all?id=${id}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: "SET_ALL_TRANSACTIONS",
        payload: res.data,
      });
    }
  })
  .catch((err) =>{
    message.error("An error occured. Please try again.")
  })
};
export const getCurrentDealerHost = (email,handleLogout) => async (dispatch) => {
  console.log("inside getCurrentDealerHost");
  apiClient.get(BASE_URL + `/api/dealerhostInfo/${encodeURIComponent(email)}`, {
    headers: {
    },
  }).then((res) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Button type="primary" size="small" onClick={() =>{
        localStorage.clear();
        handleLogout();
    }}>
        Signup
      </Button>
    );
    if (res.status === 200) {
      console.log(res.data)
      if (res.data[0] === undefined && window.location.pathname !=="/signup") {
        console.log(window.location.pathname)
        
        notification.warning({
          description: "It appears that the email is not currently registered in our system. Please Signup to create your account.",//"No user found for the email. Please contact your supervior or signup your dealership",
          duration: 0,
          onClose: () => {
            localStorage.clear();
            handleLogout();
        },
        btn,
    key,
    placement:'top',

      })
      }
      dispatch({
        type: "SET_CURRENT_DEALERHOST_DATA",
        payload: res.data[0],
      });
    }
  })
  .catch((err) =>{
    message.error("An error occured. Please try again.")
  })
};
export const getVinData = async (vin, transaction) => {
  try{
  let res = await apiClient.get(`https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/${vin}?format=JSON`);
  console.log("RES",res.data.Results[0])
    return res.data.Results[0]
  }
  catch(err){
    message.error("An error occured. Please try again.")
  }
};

export const getDealerDashboardData = async (fpDealerId) => {
  console.log("inside getDealerDashboardData");
  try {
    const res = await apiClient.get(BASE_URL + `/api/dealer-dashboard/${fpDealerId}`, {
      headers: {
      },
    });
    console.log("Dealer dashboard data:", res.data);
    return res.data;
  } catch (err) {
    console.error("Error fetching dealer dashboard data:", err);
    message.error("An error occurred while fetching dealer dashboard data.");
    throw err;
  }
};

export const getLeftSwipeData = async (fpDealerId, startDate = '', endDate = '') => {
  console.log("inside getLeftSwipeData");
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const url = BASE_URL + `/api/left-swipe-data/${fpDealerId}${params.toString() ? '?' + params.toString() : ''}`;
    
    const res = await apiClient.get(url, {
      headers: {
      },
    });
    console.log("Left swipe data:", res.data);
    return res.data;
  } catch (err) {
    console.error("Error fetching left swipe data:", err);
    message.error("An error occurred while fetching left swipe data.");
    throw err;
  }
};

export const getActiveMembersSummary = async () => {
  try {
    const res = await apiClient.get(BASE_URL + '/api/dealer-dashboard/active-members-summary', {
      headers: {
      },
    });
    return res.data;
  } catch (err) {
    console.error('Error fetching active members summary:', err);
    return { status: false };
  }
};

export const lookupInventoryByVins = async (vins) => {
  try {
    const res = await apiClient.post(
      BASE_URL + `/api/vehicle-inventory/lookup`,
      { vins },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return res.data && res.data.items ? res.data.items : [];
  } catch (err) {
    console.error('lookupInventoryByVins error', err);
    return [];
  }
};

export const getDealerHostContact = async (fpDealerId, name) => {
  if (!fpDealerId || !name) {
    return { status: false, data: null };
  }

  try {
    const res = await apiClient.get(
      BASE_URL + `/api/dealer-dashboard/${fpDealerId}/dealer-host-contact`,
      {
        params: { name },
        headers: {
        }
      }
    );
    return res.data;
  } catch (err) {
    console.error('Error fetching dealer host contact', err);
    return { status: false, error: err?.message };
  }
};

export const fetchDealerMemberChat = async (payload) => {
  if (!payload) {
    return { error: 'Invalid request payload' };
  }

  try {
    const res = await apiClient.post(
      BASE_URL + `/api/dealer-dashboard/chat`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return res.data;
  } catch (err) {
    console.error('Error fetching dealer-member chat', err);
    throw err;
  }
};

export const signupDealership = (data) => async (dispatch) => {
  console.log("inside signupDealership");
  apiClient.post(BASE_URL + `/api/dealership`, data, {
    headers: {
    },
  }).then((res) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Button type="primary" size="small" onClick={() =>{
        localStorage.clear();window.location.href = '/';
    }}>
        Login
      </Button>
    );
    if(res.data.statusCode && res.data.statusCode===200){
      notification.success({
        description:
        res.data.message,
        duration: 0,
        onClose: ()=>{window.location.href = '/'; dispatch({
          type: "RESET_LOADING"
        });
      },
      btn,
  key,
  placement:'top'
      })

      
      }
    else if (res.status === 200)  {
       dispatch({
      type: "RESET_LOADING"
    });
      notification.warning({
        description:
        res.data.message,
        duration: 0
      })
    }
     
    
  })
  .catch((err) =>{dispatch({
    type: "RESET_LOADING"
  });
    notification.error({
      message: 'Error',
      description:"An error occured. Please try again.",
      duration: 0
    })
  })
};

export const searchDealerships = async (query, filters = {}) => {
  const trimmed = query ? query.trim() : "";
  if (trimmed.length < 2) return [];

  const params = { q: trimmed };
  if (filters.state) params.state = filters.state;
  if (filters.city) params.city = filters.city;
  if (filters.zip) params.zip = filters.zip;

  const res = await apiClient.get(`${BASE_URL}/api/dealer/search`, {
    params,
    headers: {
    },
  });

  return res.data?.items || res.data || [];
};

export const onboardDealer = async (payload) => {
  const res = await apiClient.post(`${BASE_URL}/api/dealer/onboard`, payload, {
    headers: {
    },
  });
  return res.data;
};

export const getintrestRates = (data) => async (dispatch) => {
  console.log("inside getintrestRates");
  console.log(data)
  apiClient.get(BASE_URL + `/api/intrestRates?lender_id=${data.lender_id}&credit_score=${data.credit_score}`, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      console.log("INTREST_RATES",res.data)
      dispatch({
        type: "SET_INTREST_RATES_DATA",
        payload: res.data,
      });
    }
  })
  .catch((err) =>{
    message.error("An error occured. Please try again.")
  })
};
export const getBalance = (dealer_id, token) => async (dispatch) => {
  dispatch({
    type: "SET_BALANCE_LOADING",
  });
  let data = {
    type_id: `'${dealer_id}'`,
    type: "DEALER",
  };
  apiClient.post(BASE_URL + `/api/payments/balance`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      console.log(res)
      if (res.status === 200 && res.data.balance !=null) {
        dispatch({
          type: "SET_WALLET_BALANCE",
          payload: res.data,
        });
        dispatch({
          type: "RESET_BALANCE_LOADING",
        });
      }
      else if(res.data.message){
        apiClient.post(BASE_URL + `/api/payments/sdk/kyb-session`,{},  {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((res)=>{
          console.log(res)
          if (res.status === 200){
            dispatch({
              type: "SET_KYB_DATA",
              payload: res.data,
            });
            dispatch({
              type: "RESET_BALANCE_LOADING",
            });
          }
        })
      }
      else if(res.data.paymentInfo){
        console.log(res.data.paymentInfo)
        dispatch({
          type: "SET_PAYMENTS_DATA",
          payload: res.data.paymentInfo,
        });
        dispatch({
          type: "SET_WALLET_BALANCE",
          payload: {message:'Not available'},
        });
        dispatch({
          type: "RESET_BALANCE_LOADING",
        });
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};

export const getWalletTransactions = (dealer_id, token) => async (dispatch) => {
  dispatch({
    type: "SET_TRANSACTIONS_LOADING",
  });
  var firstDay = "2022-01-02"; //moment().startOf('month').format('DD-MM-YYYY');
  var lastDay = "2024-01-01"; //moment().endOf('month').format("DD-MM-YYYY");
  let data = {
    type_id: `'${dealer_id}'`,
    type: "DEALER",
    start_date: firstDay,
    end_date: lastDay,
  };
  apiClient.post(BASE_URL + `/api/payments/transactions`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: "SET_WALLET_TRANSACTIONS",
          payload: res.data,
        });
        dispatch({
          type: "RESET_TRANSACTIONS_LOADING",
        });
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};

export const withdrawFunds = (dealer_id, token, user) => async (dispatch) => {
  dispatch({
    type: "SET_TRANSACTIONS_LOADING",
  });

  let data = {
    type_id: `'${dealer_id}'`,
    type: "DEALER",
    user: user,
  };
  apiClient.put(BASE_URL + `/api/payments/withdraw`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(getWalletTransactions(dealer_id, token));
        message.success("Transfer Successful");
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
      dispatch({
        type: "RESET_TRANSACTIONS_LOADING",
      });
    });
};
export const createWalletTransfer = (token, payload) => async () => {
  return apiClient.post(BASE_URL + `/api/payments/transfer`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to process withdrawal right now.");
    })
    .catch((err) => {
      console.error("createWalletTransfer failed", err);
      message.error("Unable to process withdrawal right now. Please try again.");
      throw err;
    });
};
export const savePaymentsInfo = (dealer_id, cuid,user,token) => async (dispatch) => {
  let data = {
    id: `'${dealer_id}'`,
    type: "DEALER",
    cuid: cuid,
    user: user
  };
  apiClient.post(BASE_URL + `/api/payments`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res)
        dispatch(getBalance(dealer_id,token))
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};
export const saveBankInfo = (dealer_id, external_payments_id,user,token) => async (dispatch) => {
  let data = {
    id: `'${dealer_id}'`,
    type: "DEALER",
    ACHId: external_payments_id,
    user: user
  };
  apiClient.put(BASE_URL + `/api/payments/bankingInfo`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res)
        dispatch(getBankingInfo(dealer_id,token,user))
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};
export const getBankingInfo = (dealer_id,token,user) => async (dispatch) => {
  let data = {
    type_id: `'${dealer_id}'`,
    type: "DEALER",
    user: user
  };
  apiClient.post(BASE_URL + `/api/payments/bankingInfo`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res)
        dispatch({
          type: "SET_BANKING_INFO",
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};
export const getIavSdkToken = (cuid, token) => async (dispatch) => {
  apiClient.post(BASE_URL + `/api/payments/sdk/iav`,{customerUid:cuid}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res)
        dispatch({
          type: "SET_IAV_DATA",
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      message.error("An error occured. Please try again.");
    });
};

export const getCommercialOnboardingUrl = (token, dealer_id) => async () => {
  return apiClient.post(BASE_URL + `/api/payments/sdk/commercial-onboarding-url`, {
    type: "DEALER",
    type_id: dealer_id
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to create commercial onboarding URL.");
    })
    .catch((err) => {
      message.error("Unable to start wallet onboarding. Please try again.");
      throw err;
    });
};

export const getLinkAccountUrl = (token, dealer_id) => async () => {
  return apiClient.post(BASE_URL + `/api/payments/sdk/link-account-url`, {
    type: "DEALER",
    type_id: dealer_id
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to create link-account URL.");
    })
    .catch((err) => {
      message.error("Unable to start account linking. Please try again.");
      throw err;
    });
};
export const getOnboardingStatus = (token, dealer_id) => async () => {
  return apiClient.get(
    BASE_URL + `/api/payments/onboarding-status?type=DEALER&type_id=${dealer_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to fetch onboarding status.");
    })
    .catch((err) => {
      message.error("Unable to fetch onboarding status. Please try again.");
      throw err;
    });
};

export const getLinkedAccounts = (token, dealer_id) => async () => {
  return apiClient.get(
    BASE_URL + `/api/payments/linked-accounts?type=DEALER&type_id=${dealer_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        const items = Array.isArray(res.data?.items) ? res.data.items : [];
        return items;
      }
      throw new Error("Unable to fetch linked accounts.");
    })
    .catch((err) => {
      message.error("Unable to fetch linked accounts. Please try again.");
      throw err;
    });
};
export const getFundBalanceByUid = (token, fundUid) => async () => {
  return apiClient.get(
    BASE_URL + `/api/payments/fund/${fundUid}/balance`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to fetch fund balance.");
    })
    .catch((err) => {
      message.error("Unable to fetch wallet balance. Please try again.");
      throw err;
    });
};

export const getFundTransactionsByUid = (token, fundUid) => async () => {
  return apiClient.get(
    BASE_URL + `/api/payments/fund/${fundUid}/transactions`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error("Unable to fetch fund transactions.");
    })
    .catch((err) => {
      message.error("Unable to fetch wallet transactions. Please try again.");
      throw err;
    });
};
export const getPaymentDetails = (transactionId) => async (dispatch) => {
  console.log("inside getPaymentDetails");
  dispatch({
    type: "SET_PAYMENT_DETAILS_LOADING",
    payload: true,
  });
  
  apiClient.get(BASE_URL + `/api/payment-details/${transactionId}`, {
    headers: {
    },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log("getPaymentDetails", res.data);
        dispatch({
          type: "SET_PAYMENT_DETAILS",
          payload: res.data,
        });
        dispatch({
          type: "SET_PAYMENT_DETAILS_LOADING",
          payload: false,
        });
        console.log("Success");
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: "SET_PAYMENT_DETAILS_LOADING",
        payload: false,
      });
      message.error("An error occurred while fetching payment details. Please try again.");
    });
};

export const createPaymentRequest = async (paymentData) => {
  try {
    const response = await apiClient.post(
      BASE_URL+`/api/payment-request`,
      paymentData,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating payment request:', error);
    throw error;
  }
};




